const globe = ({
  strokeColor,
  scalar,
}: {
  strokeColor: string
  scalar: number
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${scalar * 14}`}
    height={`${scalar * 14}`}
    viewBox={`0 0 ${scalar * 14} ${scalar * 14}`}
    fill="none"
  >
    <g clipPath="url(#clip0_176_28161)">
      <path
        d="M7 1.3125C3.85902 1.3125 1.3125 3.85902 1.3125 7C1.3125 10.141 3.85902 12.6875 7 12.6875C10.141 12.6875 12.6875 10.141 12.6875 7C12.6875 3.85902 10.141 1.3125 7 1.3125Z"
        stroke={strokeColor}
        strokeWidth={`${scalar * 1.20313}`}
        strokeMiterlimit="10"
      />
      <path
        d="M7.00001 1.3125C5.41216 1.3125 3.91919 3.85902 3.91919 7C3.91919 10.141 5.41216 12.6875 7.00001 12.6875C8.58786 12.6875 10.0808 10.141 10.0808 7C10.0808 3.85902 8.58786 1.3125 7.00001 1.3125Z"
        stroke={strokeColor}
        strokeWidth={`${scalar * 1.20313}`}
        strokeMiterlimit="10"
      />
      <path
        d="M3.20825 3.31763C4.25388 4.06001 5.57021 4.5027 7.00001 4.5027C8.42981 4.5027 9.74614 4.06001 10.7918 3.31763M10.7918 10.6824C9.74614 9.94001 8.42981 9.49731 7.00001 9.49731C5.57021 9.49731 4.25388 9.94001 3.20825 10.6824"
        stroke={strokeColor}
        strokeWidth={`${scalar * 1.20313}`}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 1.3125V12.6875M12.6875 7H1.3125"
        stroke={strokeColor}
        strokeWidth={`${scalar * 1.20313}`}
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_176_28161">
        <rect width={`${scalar * 14}`} height={`${scalar * 14}`} fill="white" />
      </clipPath>
    </defs>
  </svg>
)

const password = ({
  strokeColor,
  scalar,
}: {
  strokeColor: string
  scalar: number
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${scalar * 20}`}
    height={`${scalar * 20}`}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M18.3279 9.16391V6.83128C18.3279 5.89813 18.3279 5.43156 18.1463 5.07515C17.9865 4.76164 17.7317 4.50675 17.4181 4.34701C17.0617 4.16541 16.5952 4.16541 15.662 4.16541H4.33207C3.39893 4.16541 2.93236 4.16541 2.57594 4.34701C2.26243 4.50675 2.00754 4.76164 1.8478 5.07515C1.6662 5.43156 1.6662 5.89813 1.6662 6.83128V9.83038C1.6662 10.7635 1.6662 11.2301 1.8478 11.5865C2.00754 11.9 2.26243 12.1549 2.57594 12.3146C2.93236 12.4962 3.39893 12.4962 4.33207 12.4962H9.16396M9.99704 8.33083H10.0012M14.1625 8.33083H14.1666M5.83162 8.33083H5.83579M16.0369 14.1624V12.7045C16.0369 11.8993 15.3842 11.2466 14.579 11.2466C13.7738 11.2466 13.1211 11.8993 13.1211 12.7045V14.1624M10.2053 8.33083C10.2053 8.44585 10.1121 8.5391 9.99704 8.5391C9.88202 8.5391 9.78877 8.44585 9.78877 8.33083C9.78877 8.2158 9.88202 8.12256 9.99704 8.12256C10.1121 8.12256 10.2053 8.2158 10.2053 8.33083ZM14.3707 8.33083C14.3707 8.44585 14.2775 8.5391 14.1625 8.5391C14.0474 8.5391 13.9542 8.44585 13.9542 8.33083C13.9542 8.2158 14.0474 8.12256 14.1625 8.12256C14.2775 8.12256 14.3707 8.2158 14.3707 8.33083ZM6.03989 8.33083C6.03989 8.44585 5.94665 8.5391 5.83162 8.5391C5.7166 8.5391 5.62335 8.44585 5.62335 8.33083C5.62335 8.2158 5.7166 8.12256 5.83162 8.12256C5.94665 8.12256 6.03989 8.2158 6.03989 8.33083ZM12.9961 17.4948H16.1619C16.6284 17.4948 16.8617 17.4948 17.0399 17.404C17.1967 17.3241 17.3241 17.1966 17.404 17.0399C17.4948 16.8617 17.4948 16.6284 17.4948 16.1618V15.4954C17.4948 15.0288 17.4948 14.7955 17.404 14.6173C17.3241 14.4605 17.1967 14.3331 17.0399 14.2532C16.8617 14.1624 16.6284 14.1624 16.1619 14.1624H12.9961C12.5296 14.1624 12.2963 14.1624 12.1181 14.2532C11.9613 14.3331 11.8339 14.4605 11.754 14.6173C11.6632 14.7955 11.6632 15.0288 11.6632 15.4954V16.1618C11.6632 16.6284 11.6632 16.8617 11.754 17.0399C11.8339 17.1966 11.9613 17.3241 12.1181 17.404C12.2963 17.4948 12.5296 17.4948 12.9961 17.4948Z"
      stroke={strokeColor}
      strokeWidth={`${scalar * 1.25}`}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const magicLink = ({
  strokeColor,
  scalar,
}: {
  strokeColor: string
  scalar: number
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${scalar * 20}`}
    height={`${scalar * 20}`}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M7.08125 12.9128L12.9128 7.08117M7.49779 3.33231V1.66614M12.4963 16.6617V18.3278M3.33237 7.49773H1.6662M16.6617 12.4962H18.3279M4.09398 4.09392L2.91583 2.91576M15.9001 15.9L17.0783 17.0781M9.99707 14.7095L8.22983 16.4768C6.92847 17.7781 4.81855 17.7781 3.5172 16.4768C2.21584 15.1754 2.21584 13.0655 3.51719 11.7641L5.28443 9.99691M14.7097 9.99691L16.4769 8.22967C17.7783 6.92831 17.7783 4.81839 16.4769 3.51703C15.1756 2.21567 13.0657 2.21567 11.7643 3.51703L9.99707 5.28427"
      stroke={strokeColor}
      strokeWidth={`${scalar * 1.25}`}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const plus = ({strokeColor, scalar}: {strokeColor: string; scalar: number}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${scalar * 12}`}
    height={`${scalar * 13}`}
    viewBox={`0 0 12 13`}
    fill="none"
  >
    <path
      d="M6 3V10M2.5 6.5H9.5"
      stroke={strokeColor}
      strokeWidth={`${scalar * 0.5}`}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const SettingsIcon = ({
  strokeColor,
  scalar,
}: {
  strokeColor: string
  scalar: number
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${scalar * 20}`}
    height={`${scalar * 20}`}
    viewBox={`0 0 ${scalar * 20} ${scalar * 20}`}
    fill="none"
  >
    <g clipPath="url(#clip0_239_30273)">
      <path
        d="M9.99704 12.4962C11.3773 12.4962 12.4963 11.3773 12.4963 9.99698C12.4963 8.61668 11.3773 7.49773 9.99704 7.49773C8.61674 7.49773 7.49779 8.61668 7.49779 9.99698C7.49779 11.3773 8.61674 12.4962 9.99704 12.4962Z"
        stroke={`${strokeColor}`}
        strokeWidth="1.66617"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6014 12.269C15.5006 12.4975 15.4705 12.7509 15.5151 12.9965C15.5596 13.2422 15.6768 13.4689 15.8514 13.6474L15.8968 13.6928C16.0376 13.8335 16.1493 14.0006 16.2256 14.1845C16.3018 14.3683 16.341 14.5654 16.341 14.7645C16.341 14.9636 16.3018 15.1607 16.2256 15.3445C16.1493 15.5284 16.0376 15.6955 15.8968 15.8361C15.7561 15.977 15.5891 16.0887 15.4052 16.1649C15.2213 16.2412 15.0242 16.2804 14.8251 16.2804C14.6261 16.2804 14.429 16.2412 14.2451 16.1649C14.0612 16.0887 13.8942 15.977 13.7535 15.8361L13.7081 15.7907C13.5296 15.6161 13.3029 15.499 13.0572 15.4544C12.8115 15.4099 12.5581 15.44 12.3297 15.5408C12.1057 15.6368 11.9146 15.7962 11.7801 15.9994C11.6455 16.2026 11.5733 16.4407 11.5723 16.6844V16.8131C11.5723 17.2148 11.4127 17.6001 11.1287 17.8842C10.8446 18.1682 10.4594 18.3278 10.0576 18.3278C9.65591 18.3278 9.27064 18.1682 8.98658 17.8842C8.70252 17.6001 8.54293 17.2148 8.54293 16.8131V16.745C8.53707 16.4943 8.45593 16.2512 8.31006 16.0472C8.16418 15.8433 7.96033 15.6879 7.72499 15.6014C7.49657 15.5006 7.24317 15.4705 6.99749 15.515C6.75181 15.5596 6.52511 15.6767 6.34662 15.8513L6.30118 15.8967C6.1605 16.0376 5.99345 16.1493 5.80957 16.2255C5.62569 16.3017 5.42858 16.341 5.22953 16.341C5.03047 16.341 4.83337 16.3017 4.64949 16.2255C4.46561 16.1493 4.29855 16.0376 4.15788 15.8967C4.01705 15.7561 3.90532 15.589 3.8291 15.4051C3.75287 15.2212 3.71364 15.0241 3.71364 14.8251C3.71364 14.626 3.75287 14.4289 3.8291 14.245C3.90532 14.0612 4.01705 13.8941 4.15788 13.7534L4.20332 13.708C4.37792 13.5295 4.49504 13.3028 4.53959 13.0571C4.58413 12.8114 4.55406 12.558 4.45324 12.3296C4.35724 12.1056 4.19783 11.9146 3.99464 11.78C3.79145 11.6455 3.55335 11.5732 3.30965 11.5723H3.1809C2.77917 11.5723 2.3939 11.4127 2.10984 11.1286C1.82578 10.8446 1.6662 10.4593 1.6662 10.0576C1.6662 9.65585 1.82578 9.27058 2.10984 8.98652C2.3939 8.70245 2.77917 8.54287 3.1809 8.54287H3.24906C3.49974 8.53701 3.74285 8.45587 3.9468 8.30999C4.15075 8.16412 4.3061 7.96027 4.39266 7.72493C4.49347 7.4965 4.52354 7.24311 4.479 6.99743C4.43445 6.75175 4.31733 6.52505 4.14273 6.34656L4.09729 6.30112C3.95646 6.16044 3.84474 5.99339 3.76851 5.80951C3.69228 5.62562 3.65305 5.42852 3.65305 5.22947C3.65305 5.03041 3.69228 4.83331 3.76851 4.64943C3.84474 4.46555 3.95646 4.29849 4.09729 4.15782C4.23797 4.01699 4.40502 3.90526 4.5889 3.82904C4.77278 3.75281 4.96989 3.71358 5.16894 3.71358C5.36799 3.71358 5.5651 3.75281 5.74898 3.82904C5.93286 3.90526 6.09991 4.01699 6.24059 4.15782L6.28603 4.20326C6.46452 4.37786 6.69122 4.49498 6.9369 4.53952C7.18259 4.58407 7.43598 4.554 7.66441 4.45318H7.72499C7.949 4.35718 8.14004 4.19777 8.2746 3.99458C8.40916 3.79139 8.48137 3.55329 8.48234 3.30959V3.18084C8.48234 2.77911 8.64193 2.39384 8.92599 2.10978C9.21005 1.82572 9.59532 1.66614 9.99704 1.66614C10.3988 1.66614 10.784 1.82572 11.0681 2.10978C11.3522 2.39384 11.5117 2.77911 11.5117 3.18084V3.249C11.5127 3.4927 11.5849 3.73081 11.7195 3.93399C11.8541 4.13718 12.0451 4.29659 12.2691 4.3926C12.4975 4.49341 12.7509 4.52348 12.9966 4.47894C13.2423 4.43439 13.469 4.31727 13.6475 4.14267L13.6929 4.09723C13.8336 3.9564 14.0006 3.84468 14.1845 3.76845C14.3684 3.69222 14.5655 3.65299 14.7646 3.65299C14.9636 3.65299 15.1607 3.69222 15.3446 3.76845C15.5285 3.84468 15.6955 3.9564 15.8362 4.09723C15.977 4.2379 16.0888 4.40496 16.165 4.58884C16.2412 4.77272 16.2804 4.96982 16.2804 5.16888C16.2804 5.36793 16.2412 5.56504 16.165 5.74892C16.0888 5.9328 15.977 6.09985 15.8362 6.24053L15.7908 6.28597C15.6162 6.46446 15.499 6.69116 15.4545 6.93684C15.41 7.18252 15.44 7.43592 15.5408 7.66435V7.72493C15.6368 7.94893 15.7963 8.13997 15.9994 8.27454C16.2026 8.4091 16.4407 8.48131 16.6844 8.48228H16.8132C17.2149 8.48228 17.6002 8.64187 17.8842 8.92593C18.1683 9.20999 18.3279 9.59526 18.3279 9.99698C18.3279 10.3987 18.1683 10.784 17.8842 11.068C17.6002 11.3521 17.2149 11.5117 16.8132 11.5117H16.745C16.5013 11.5127 16.2632 11.5849 16.06 11.7194C15.8568 11.854 15.6974 12.045 15.6014 12.269Z"
        stroke={`${strokeColor}`}
        strokeWidth="1.66617"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_239_30273">
        <rect
          width={`${scalar * 19.994}`}
          height={`${scalar * 19.994}`}
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
)

const LogOutIcon = ({
  strokeColor,
  scalar,
}: {
  strokeColor: string
  scalar: number
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox={`0 0 ${scalar * 24} ${scalar * 24}`}
    strokeWidth={`${scalar * 1.5}`}
    stroke={strokeColor}
    className="size-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0 3 3m-3-3h12.75"
    />
  </svg>
)

const arrowUp = ({
  strokeColor,
  scalar,
}: {
  strokeColor: string
  scalar: number
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${scalar * 20}`}
    height={`${scalar * 21}`}
    viewBox={`0 0 ${scalar * 20} ${scalar * 21}`}
    fill="none"
  >
    <path
      d="M6.67569 10.9591L10.008 14.2914M10.008 14.2914L13.3404 10.9591M10.008 14.2914L10.008 7.62674M1.67718 10.9591C1.67718 6.35807 5.40703 2.62823 10.008 2.62823C14.609 2.62823 18.3389 6.35808 18.3389 10.9591C18.3389 15.5601 14.609 19.2899 10.008 19.2899C5.40702 19.2899 1.67718 15.5601 1.67718 10.9591Z"
      stroke={strokeColor}
      strokeWidth="1.35"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const atom = ({strokeColor, scalar}: {strokeColor: string; scalar: number}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${scalar * 20}`}
    height={`${scalar * 20}`}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M14.2537 12.7852C14.0281 13.0402 13.7915 13.292 13.544 13.5395C9.9653 17.1182 5.48172 18.4369 3.52968 16.4849C2.19141 15.1466 2.39043 12.6185 3.80107 10.0078M5.73483 7.25945C5.96951 6.9926 6.21639 6.72919 6.47508 6.4705C10.0538 2.89177 14.5374 1.57307 16.4894 3.5251C17.8286 4.86429 17.6284 7.39498 16.2151 10.0076M13.544 6.4705C17.1228 10.0492 18.4415 14.5328 16.4894 16.4849C14.5374 18.4369 10.0538 17.1182 6.47508 13.5395C2.89634 9.96072 1.57764 5.47714 3.52968 3.5251C5.48172 1.57307 9.9653 2.89176 13.544 6.4705ZM10.8253 9.98758C10.8253 10.4477 10.4523 10.8207 9.99222 10.8207C9.53212 10.8207 9.15913 10.4477 9.15913 9.98758C9.15913 9.52748 9.53212 9.1545 9.99222 9.1545C10.4523 9.1545 10.8253 9.52748 10.8253 9.98758Z"
      stroke={strokeColor}
      strokeWidth={`${scalar * 1.66617}`}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const arrowDown = ({
  strokeColor,
  scalar,
}: {
  strokeColor: string
  scalar: number
}) => (
  <div className="rotate-180">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={`${scalar * 20}`}
      height={`${scalar * 21}`}
      viewBox={`0 0 ${scalar * 20} ${scalar * 21}`}
      fill="none"
    >
      <path
        d="M6.67569 10.9591L10.008 14.2914M10.008 14.2914L13.3404 10.9591M10.008 14.2914L10.008 7.62674M1.67718 10.9591C1.67718 6.35807 5.40703 2.62823 10.008 2.62823C14.609 2.62823 18.3389 6.35808 18.3389 10.9591C18.3389 15.5601 14.609 19.2899 10.008 19.2899C5.40702 19.2899 1.67718 15.5601 1.67718 10.9591Z"
        stroke={strokeColor}
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
)

const folder = ({
  strokeColor,
  scalar,
}: {
  strokeColor: string
  scalar: number
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${scalar * 15}`}
    height={`${scalar * 15}`}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10.8301 5.8316L9.90079 3.97292C9.63332 3.43799 9.49958 3.17051 9.30006 2.9751C9.12362 2.80229 8.91097 2.67086 8.6775 2.59033C8.41349 2.49927 8.11444 2.49927 7.51636 2.49927H4.33207C3.39893 2.49927 2.93236 2.49927 2.57594 2.68087C2.26243 2.84061 2.00754 3.0955 1.8478 3.40901C1.6662 3.76542 1.6662 4.232 1.6662 5.16514V5.8316M1.6662 5.8316H14.3291C15.7288 5.8316 16.4287 5.83161 16.9633 6.10401C17.4335 6.34362 17.8159 6.72596 18.0555 7.19622C18.3279 7.73084 18.3279 8.4307 18.3279 9.83041V13.496C18.3279 14.8957 18.3279 15.5955 18.0555 16.1302C17.8159 16.6004 17.4335 16.9828 16.9633 17.2224C16.4287 17.4948 15.7288 17.4948 14.3291 17.4948H5.665C4.26529 17.4948 3.56543 17.4948 3.03081 17.2224C2.56055 16.9828 2.17821 16.6004 1.9386 16.1302C1.6662 15.5955 1.6662 14.8957 1.6662 13.496V5.8316Z"
      stroke={strokeColor}
      strokeWidth={`${scalar * 2}`}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const infoHex = ({
  strokeColor,
  scalar,
}: {
  strokeColor: string
  scalar: number
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${scalar * 20}`}
    height={`${scalar * 20}`}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M9.99703 13.3294V9.99705M9.99703 6.66471H10.0054M2.49927 6.61593V13.3782C2.49927 13.6636 2.49927 13.8063 2.54133 13.9336C2.57853 14.0462 2.63936 14.1496 2.71973 14.2368C2.81058 14.3354 2.93534 14.4047 3.18487 14.5434L9.3497 17.9683C9.58596 18.0995 9.70409 18.1651 9.8292 18.1909C9.93993 18.2137 10.0541 18.2137 10.1649 18.1909C10.29 18.1651 10.4081 18.0995 10.6444 17.9683L16.8092 14.5434C17.0587 14.4047 17.1835 14.3354 17.2743 14.2368C17.3547 14.1496 17.4155 14.0462 17.4527 13.9336C17.4948 13.8063 17.4948 13.6636 17.4948 13.3782V6.61593C17.4948 6.33048 17.4948 6.18775 17.4527 6.06046C17.4155 5.94784 17.3547 5.84447 17.2743 5.75726C17.1835 5.65867 17.0587 5.58936 16.8092 5.45073L10.6444 2.02583C10.4081 1.89457 10.29 1.82894 10.1649 1.80321C10.0541 1.78044 9.93993 1.78044 9.8292 1.80321C9.70409 1.82894 9.58596 1.89457 9.3497 2.02583L3.18487 5.45073C2.93534 5.58936 2.81058 5.65867 2.71973 5.75726C2.63936 5.84447 2.57853 5.94784 2.54133 6.06046C2.49927 6.18775 2.49927 6.33048 2.49927 6.61593Z"
      stroke={strokeColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const icons = {
  globe,
  plus,
  settings: SettingsIcon,
  logout: LogOutIcon,
  arrowUp,
  arrowDown,
  magicLink,
  password,
  atom,
  folder,
  infoHex,
}

export const Icons = ({
  iconName,
  className,
  strokeColor,
  scalar,
}: {
  iconName: string
  className?: string
  strokeColor?: string
  scalar?: number
}) => {
  const IconComp = icons[iconName as keyof typeof icons]
  return (
    <div className={className}>
      {IconComp({strokeColor: strokeColor || "#636C76", scalar: scalar || 1})}
    </div>
  )
}
